import { Link } from 'react-router-dom';
import { navItems, resourceItems } from '../data/siteData';
import Button from './Button';
import Logo from './Logo';

const columns = [
  { title: 'Product', links: navItems },
  { title: 'Resources', links: resourceItems },
  { title: 'Company', links: [{ label: 'About', to: '/about' }, { label: 'Contact', to: '/contact' }, { label: 'Waitlist', to: '/waitlist' }] },
  { title: 'Legal', links: [{ label: 'Privacy', to: '/privacy' }, { label: 'Terms', to: '/terms' }] },
];

export default function Footer() {
  return (
    <footer className="border-t-2 border-ink bg-yellow/70 py-12 dark:border-canvas dark:bg-[#2a2518]">
      <div className="container-shell">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_2fr]">
          <div>
            <Logo />
            <p className="mt-5 max-w-md text-sm leading-7 text-muted dark:text-slate-300">
              Tavio is a premium AI-first marketing prototype for modern workspace operations.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Button to="/demo">Book Demo</Button>
              <Button to="/waitlist" variant="secondary">Join Waitlist</Button>
            </div>
          </div>
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {columns.map((column) => (
              <div key={column.title}>
                <h2 className="text-sm font-extrabold text-ink dark:text-canvas">{column.title}</h2>
                <ul className="mt-4 space-y-3">
                  {column.links.map((link) => (
                    <li key={link.to}>
                      <Link className="focus-ring rounded text-sm font-semibold text-ink/70 hover:text-danger dark:text-canvas/80 dark:hover:text-yellow" to={link.to}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-4 border-t-2 border-ink pt-6 text-sm text-ink/70 dark:border-canvas dark:text-canvas/70 sm:flex-row sm:items-center sm:justify-between">
          <p>Copyright © 2026 Tavio. All rights reserved.</p>
          <p>Analytics placeholders: Google Analytics, Microsoft Clarity.</p>
        </div>
      </div>
    </footer>
  );
}
